import styled from 'styled-components'
import { MessageErrorUnstyled } from './unstyled'

export const MessageErrorInput = styled(MessageErrorUnstyled)`
  color: ${props => props.theme.colors.red};
  margin-top: 8px;
  font-size: ${props => props.theme.fontSizes.form.messageErrorInput};
`



// WEBPACK FOOTER //
// ./src/Components/Message/Error/input.js